import { BEACON_MODE_CLASSNAMES } from '@trp-dms-digital-shared/ds-ui-library-common';

/**
 * Checks the element to see if it has a beacon mode class on it
 * @param element - The HTML element to check.
 * @returns `true` if the element has a beacon mode class, `false` otherwise.
 */
export function hasBeaconMode(element: HTMLElement) {
  return BEACON_MODE_CLASSNAMES.some((mode) =>
    element.classList?.contains(mode),
  );
}

/**
 * Finds the closest ancestor of the given element that has a class name containing "beacon-on-".
 * @param element - The HTML element to start the search from.
 * @returns The closest ancestor element with a class name containing "beacon-on-", or null if not found.
 */
export function closestBeaconModeAncestor(element: HTMLElement) {
  return element.closest("[class*='beacon-on-']");
}

/**
 * Gets the closest beacon mode of the given element.
 * @param element - The HTML element to start the search from.
 * @returns The closest beacon classname, or an empty string if not found.
 */
export function getClosestBeaconMode(element: HTMLElement) {
  const closestElement = closestBeaconModeAncestor(element);

  for (const classname of BEACON_MODE_CLASSNAMES) {
    if (closestElement?.classList.contains(classname)) {
      return classname;
    }
  }

  return '';
}

/**
 * Removes any and all beacon-on-* classes from an element
 * @param element - The HTML element that may have beacon classes
 */
export function removeBeaconMode(element: HTMLElement) {
  for (const classname of BEACON_MODE_CLASSNAMES) {
    if (element?.classList?.contains(classname)) {
      element.classList.remove(classname);
    }
  }
}
